import React from 'react'

import {
  CarDependent,
  SomeWhatWalkable,
  Walkable,
  WalkerParadise
} from '../../svg'

export const walkabilityCategories = [
  {
    code: 'walkers_paradise',
    color: '#5DD980',
    title: 'Paraíso peatonal',
    description:
      'Puedes realizar tus actividades diarias caminando en 15 minutos.',
    icon: <WalkerParadise />
  },
  {
    code: 'walkable',
    color: '#1B9FFF',
    title: 'Muy caminable',
    description:
      'Puedes caminar con tranquilidad. En ocasiones puntuales necesitas otro medio de transporte.',
    icon: <Walkable />
  },
  {
    code: 'somewhat_walkable',
    color: '#E8BC7A',
    title: 'Algo caminable',
    description:
      'Puedes caminar pero puede que sea complicado. Muchas veces necesitas otro medio de transporte.',
    icon: <SomeWhatWalkable />
  },
  {
    code: 'car_dependent',
    color: '#FF0000',
    title: 'Dependencia del auto',
    description:
      'Dependes de un auto, taxi, o transporte público para poder realizar tus actividades diarias.',
    icon: <CarDependent />
  }
]

export const trafficCategories = [
  {
    code: 'low',
    color: '#5DD980',
    title: 'Tráfico fluido',
    iconCount: 1
  },
  {
    code: 'fluid',
    color: '#5DD980',
    title: 'Tráfico fluido',
    iconCount: 1
  },
  {
    code: 'moderate',
    color: '#1B9FFF',
    title: 'Tráfico moderado',
    iconCount: 2
  },
  {
    code: 'heavy',
    color: '#E8BC7A',
    title: 'Tráfico congestionado',
    iconCount: 3
  },
  {
    code: 'high',
    color: '#E8BC7A',
    title: 'Tráfico congestionado',
    iconCount: 3
  },
  {
    code: 'very_heavy',
    color: '#FF0000',
    title: 'Tráfico intenso',
    iconCount: 4
  },
  {
    code: 'very_high',
    color: '#FF0000',
    title: 'Tráfico intenso',
    iconCount: 4
  }
]
